export interface Currency {
  code: string;
  name: string;
  symbol: string;
}

export interface CurrencyStoreState {
  currencies: Currency[];
  loading: boolean;
}

export function createInitialCurrencyState(): CurrencyStoreState {
  return {
    currencies: [],
    loading: false,
  };
}
